import { formatDateWithLocalTZ } from '@ticomix/common';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { ITokenResponseApiResponse } from './i-itoken-response-api-response';
import { TokenResponse } from './token-response';
import { throwException, blobToText } from './api-utilities';



export class TokenResponseApiResponse implements ITokenResponseApiResponse {
    Success!: boolean;
    Message!: string;
    Data?: TokenResponse | null;
    Errors?: { [key: string]: string[]; } | null;

    constructor(data?: ITokenResponseApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.Data = data.Data && !(<any>data.Data).toJSON ? new TokenResponse(data.Data) : <TokenResponse>this.Data;
        }
        if (!data) {
            this.Success = false;
            this.Message = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Success = _data["Success"] !== undefined ? _data["Success"] : false;
            this.Message = _data["Message"] !== undefined ? _data["Message"] : "";
            this.Data = _data["Data"] ? TokenResponse.fromJS(_data["Data"]) : <any>null;
            if (_data["Errors"]) {
                this.Errors = {} as any;
                for (let key in _data["Errors"]) {
                    if (_data["Errors"].hasOwnProperty(key))
                        (<any>this.Errors)![key] = _data["Errors"][key] !== undefined ? _data["Errors"][key] : [];
                }
            }
            else {
                this.Errors = <any>null;
            }
        }
    }

    static fromJS(data: any): TokenResponseApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponseApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.Success !== undefined ? this.Success : <any>null;
        data["Message"] = this.Message !== undefined ? this.Message : <any>null;
        data["Data"] = this.Data ? this.Data.toJSON() : <any>null;
        if (this.Errors) {
            data["Errors"] = {};
            for (let key in this.Errors) {
                if (this.Errors.hasOwnProperty(key))
                    (<any>data["Errors"])[key] = this.Errors[key] !== undefined ? this.Errors[key] : <any>null;
            }
        }
        return data;
    }

}